<template>
    <section class="pda-default">
        <div class="t-headline5 mgt-3">
            {{$t('277')}}
            <!-- 나의 패턴 만들기 -->
        </div>
        <div class="t-body3 mgt-6 t-color-content1">
            {{$t('278')}}
            <!-- 프로필로 사용할 패턴을 설정하세요. -->
        </div>

        <div class="mgt-47">
            <div class="d-flex justify-content-center">
                <div class="profile-wrap" :style="{'background': backgroundColor}">
                    <canvas id="pattenCanvas" ref="pattenCanvas" width="170" height="170"> </canvas>
                </div>
            </div>
            <!-- <div>
                <sketch-picker :value="colors"></sketch-picker>
            </div> -->
            
             

            <div class="mgt-30 d-flex justify-content-center t-color-content1">
                <div class="d-flex justify-content-center align-items-center mgr-8 mgl-8">
                    <div class="t-body2 mgr-8 mgl-8">
                        {{$t('279')}}
                        <!-- 배경색 -->
                    </div>
                    <verte menuPosition="center" 
                        class="select-color-picker"
                        :style="{'background': backgroundColor}"
                        @input="updateBackgroundColor" model="hex" :value="backgroundColor">
                        
                    </verte>
                    
                </div>
                <div class="d-flex justify-content-center align-items-center mgr-8 mgl-8">
                    <div class="t-body2 mgr-8 mgl-8">
                        {{$t('280')}}
                        <!-- 패턴색 -->
                    </div>
                    <verte menuPosition="center" 
                        class="select-color-picker"                        
                        :style="{'background': pattenColor}"
                        @input="updatePattenColor" model="hex" :value="pattenColor">                        
                    </verte>
                </div>
            </div>

            <div class="mgt-60">
                <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="saveImage()">
                    {{$t('281')}}
                    <!-- 저장하기 -->
                </button>
            </div>

            <!-- <div class="mt40">
                <a @click="saveImage()">이미지로 저장</a>
            </div> -->
            <!-- {{pattenValue}} <br> -->
            <!-- {{profileData.pattenValue}} -->
        </div>
    </section>
    
</template>

<script>
/**
 * 멤버십 - 프로필 패턴 변경 컴포넌트(membership - change profile patten component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import Verte from 'verte'
import 'verte/dist/verte.css'
import httpService from '@/api/httpService.js'
import memberApi from '@/api/memberApi.js'

export default {
    components: {
        Verte 
        
    },
    data() {
        return {
            elemCanvas: null,
            context: null,
            elements: [],
            rectWidth: 0,
            rectHeight: 0,
            padding: 6.5,
            defaultColor: "#dbdbdb",
            backgroundColor: "#f6f8f9",
            pattenColor: "#546e7a",
            pattenValue: [],
        }
    },
    mounted() {    
        
        // 캔버스 그리기(create canvas)
        this.elemCanvas = this.$refs.pattenCanvas
        this.context = this.elemCanvas.getContext("2d"); // 캔버스 객체 생성

        // 캔버스 화면 지우기(clear canvas)
        this.context.clearRect(0, 0, this.elemCanvas.width, this.elemCanvas.height);

        let rectX = 0;
        let rectY = 0;
        
        let rectWidth = this.elemCanvas.width / 4 - (this.padding * 2) ;
        let rectHeight = this.elemCanvas.height / 4 - (this.padding * 2) ;
        let cornerRadius = 5;
        

        // 라운드 설정(set round canvas)
        this.context.lineJoin = "round";
        this.context.lineWidth = cornerRadius;
        this.context.beginPath();
        
        // 캔버스 요소 정보 설정(set canvas element information)
        for(let i=1 ; i <= 4; i++) {
            rectY = this.padding*((i-1)+i) + rectHeight*(i-1)
            for(let j=1 ; j <= 4; j++) {
                rectX = this.padding * ((j-1)+j)+ ((rectWidth) * (j-1))
                this.elements.push({
                    colour: this.defaultColor,
                    width: rectWidth-cornerRadius,
                    height: rectHeight-cornerRadius,
                    top: rectY+(cornerRadius/2),
                    left: rectX+(cornerRadius/2),
                    text: (i-1)*4+j,
                    textColour: '#fff'
                })
            }
        }


        let elemLeft = this.elemCanvas.offsetLeft
        let elemTop = this.elemCanvas.offsetTop

        // 캔버스 클릭 이벤트 설정(set event canvas click)
        this.elemCanvas.addEventListener('click', (event) => {
            let x = event.pageX - elemLeft
            let y = event.pageY - elemTop
            // console.log(x,y)
            
            this.elements.forEach((element, index) => {
                //console.log(element.text ,element);
                if (y > element.top && y < element.top + element.height + cornerRadius && x > element.left && x < element.left + element.width + cornerRadius) {
                    if (element.colour !== this.defaultColor) {
                        element.colour = this.defaultColor
                        this.pattenValue[index] = 0
                    }else {
                        element.colour = this.pattenColor
                        this.pattenValue[index] = 1
                    }
                    this.pattenValue.push()
                    this.drawPatten()
                }
            });

            
            
        }, false);
        
        // 프로필 패턴 정보 API 호출(get profile patten)
        memberApi.getProileImage().then((response)=>{
            let profileData = response.data.data
            // console.log('profileData', profileData);
            if (profileData) {

                this.defaultColor = profileData.defaultColor || this.defaultColor
                this.backgroundColor = profileData.backgroundColor || this.backgroundColor
                this.pattenColor = profileData.pattenColor || this.pattenColor
                if (!profileData.pattenValue.length) {
                    this.pattenValue = [0,0,0,0,
                                        0,0,0,0,
                                        0,0,0,0,
                                        0,0,0,0]

                }else {
                    this.pattenValue = profileData.pattenValue
                }

                // 패턴 이미지 색상 설정(set patten color)
                this.elements.forEach((element, index) => {
                    console.log(index);
                    if (this.pattenValue[index] === 1) {
                        element.colour = this.pattenColor
                    } else {
                        element.colour = this.defaultColor
                    }
                })
                
                this.drawPatten()
            }
        })
        
    },

    methods: {
        // 패턴 그리기(draw patten)
        drawPatten() {
            this.context.clearRect(0, 0, this.elemCanvas.width, this.elemCanvas.height)
            this.context.fillStyle = this.backgroundColor
            this.context.fillRect(0,0,this.elemCanvas.width, this.elemCanvas.height)
            console.log('elements', this.elements);
            
            this.elements.forEach((element) => {
                this.context.strokeStyle = element.colour; // 선 색(line color)
                this.context.fillStyle = element.colour; // 채운 사각형 색(fill color)
                this.context.strokeRect(element.left, element.top, element.width, element.height)
                this.context.fillRect(element.left, element.top, element.width, element.height)
            })
            
        },

        // 이미지 업로드 및 프로필 저장(Upload image and save profile)
        saveImage() {
             let canvasData = this.elemCanvas.toDataURL("image/png");
             let blob = this.dataURItoBlob(canvasData);
             console.log(canvasData);

             let formData = new FormData()
             formData.append('file', blob, 'profile.png')

             httpService.upload(formData)
                .then((response) => {
                    let params = {
                        file: response.data.data[0],
                        backgroundColor: this.backgroundColor,
                        defaultColor: this.defaultColor,
                        pattenColor: this.pattenColor,
                        pattenValue: this.pattenValue,
                    }

                    memberApi.uploadProileImage(params).then((response)=>{
                        console.log(response);
                        localStorage.setItem('setPetern','yes')
                        this.$router.go(-1)
                        // this.$snackOpen({
                        //     contents: this.$t('go to the Navigation drawer screen'),
                        //     btnDisplayYN: false,
                        //     btnDisplay: ''
                        // }).then(() => {})
                        
                    })
                    
                })
                .catch((err) => {
                    console.log('FAILURE!!', err);
                });
            
        }, 

        // Color Picker 배경색 설정(set background color)
        updateBackgroundColor(value) {
            // console.log('updateBackgroundColor', value);
            this.backgroundColor = value
            this.drawPatten()
        },

        // Color Picker 패턴색 설정(set patten color)
        updatePattenColor(value) {
            // console.log('updatePattenColor', value);
            this.pattenColor = value
            this.elements.forEach((element) => {
                if (element.colour !== this.defaultColor) {
                    element.colour = this.pattenColor
                }
            })
            this.drawPatten()
        },

        // 파라미터 설정(set parameter)
        setParams() {
            let params = {
                backgroundColor: this.backgroundColor,
                defaultColor: this.defaultColor,
                pattenColor: this.backgroundColor,
                pattenValue: []
            }

            this.elements.forEach((element) => {
                if (element.colour !== this.defaultColor) {
                    params.pattenValue.push(1)
                }else {
                    params.pattenValue.push(0)
                }
            })
        },
        
        // 캔버스 이미지 전송위한 Blob 함수(Blob function for canvas image transfer)
        dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            let byteString
            if (dataURI.split(',')[0].indexOf('base64') >= 0){
                byteString = atob(dataURI.split(',')[1])
            }else {
                byteString = unescape(dataURI.split(',')[1])
            }

            // separate out the mime component
            let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

            // write the bytes of the string to a typed array
            let ia = new Uint8Array(byteString.length)
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
            }
            return new Blob([ia], {type:mimeString})
        }
    }
}
</script>